import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import {TransitionMotion, spring, presets} from 'react-motion';

import Col from './Col';

class PageMain extends Component {

    static propTypes = {
        className: React.PropTypes.string,
        title: React.PropTypes.node,
        children: React.PropTypes.node,
        sideNav: React.PropTypes.bool,
        full: React.PropTypes.bool
    };

    getStartValue() {
        return {
            card: {
                marginTop: spring(-20, [200,30]),
                opacity: spring(0, [200,30])
            }
        };
    }

    getEndValue() {
        return {
            card: {
                marginTop: spring(-60, [200,30]),
                opacity: spring(1, [200,30])
            }
        };
    }

    render() {
        let classes = {};

        let {className, children, title, sideNav, full, ...props} = this.props;

        let colClasses = {
            'offset-m3': !sideNav && !full
        };

        let colM = full ? 12 : 9;

        return (
            <div className={classNames(classes, className)} {...props}>
                <Col s={12} m={colM} className={classNames(colClasses)}>
                    <TransitionMotion defaultStyles={this.getStartValue()}
                                      styles={this.getEndValue()}
                                      >
                        {configs => {
                            const { ...style } = configs.card;
                            return (<div className="page-main__card card-panel" style={style}>
                                <div className="card-title">{title}</div>
                                <div className="card-content">
                                    {children}
                                </div>
                            </div>);
                            }
                        }
                    </TransitionMotion>
                </Col>
            </div>
        );
    }
}

export default PageMain;